import { TTaskType } from 'volta/models/task';

import Component from '@glimmer/component';

import type Task from 'volta/models/task';

interface IArgs {
  tasks: Task[];
  taskType: TTaskType;
}

export default class TasksKitFilters extends Component<IArgs> {
  get selectFilters() {
    const filters = [];
    if (this.args.taskType === 'EXECUTION_TASK') {
      filters.push('EXECUTION_TASK');
    } else if (this.args.taskType === 'PLANNING_TASK') {
      filters.push('PLANNING_TASK');
    } else {
      filters.push('SKU_TASK');
      filters.push('EXECUTION_TASK');
      filters.push('PLANNING_TASK');
    }
    return filters;
  }
}
